module.exports = __webpack_public_path__ + "static/media/help.e457b921.svg";